export class CloneForm {
  static readonly type = '[Contract.Form] Clone Form';
  constructor(public articleID: number, public copies: number = 1) {}
}

export class DeleteForm {
  static readonly type = '[Contract.Form] Delete Form';
  constructor(public articleID: number) {}
}

export class RestoreForm {
  static readonly type = '[Contract.Form] Restore Form';
  constructor(public articleID: number) {}
}

export class AddForm {
  static readonly type = '[Contract.Form] Add Form';
  constructor(public lineID: string, public Form: any) {}
}

export class UpdateForm {
  static readonly type = '[Contract.Form] Update Form';
  constructor(public Form: any) {}
}
